import {uniqueId} from 'lodash';

type SharedPromiseStore<T = any> = {
    fn: () => Promise<T>;
    originalPromise: Promise<T>,
    promises: {
        resolve: (value: T | PromiseLike<T>) => void;
        reject: (reason?: any) => void
    }[];
}
export class SharedPromise<T> {
    private static store: {[key: string]: SharedPromiseStore} = {};

    constructor(fn: () => Promise<T>, private key: string = uniqueId('shared-promise')) {
        if (!SharedPromise.store[key]) {
            SharedPromise.store[key] = {
                fn,
                originalPromise: null,
                promises: []
            };
        }
    }

    run(): Promise<T> {
        const currentStore: SharedPromiseStore<T> = SharedPromise.store[this.key];
        if (!currentStore) {
            return Promise.reject(`The promise "${this.key}" is already completed`);
        }
        const promise = new Promise<T>((resolve, reject) => {
            currentStore.promises.push({resolve, reject});
        });
        if (!currentStore.originalPromise) {
            currentStore.originalPromise = currentStore.fn();
            currentStore.originalPromise.then((value: T) => {
                currentStore.promises.every(({resolve}) => resolve(value));
            }).catch((error) => {
                currentStore.promises.every(({reject}) => reject(error));
            }).finally(() => {
                delete SharedPromise.store[this.key];
            });
        }
        return promise;
    }
}